import { Injectable } from '@angular/core';
import { ConnectionService } from '../connection-service';

export interface DoctorInfo {
  name: string;
  imageUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserAllocatedDoctorService {
  private readonly DEFAULT_DOCTOR_NAME = 'Dr. Charu';
  private readonly DEFAULT_DOCTOR_IMAGE = 'https://storage.googleapis.com/heallo-other-user-files/doctor_api_charu_07302024_1722317224002.jpg';
  readonly DEFAULT_DOCTOR_IMAGE_THUMBNAIL = 'https://storage.googleapis.com/heallo-other-user-files/doctor_api_charu_07302024_1722317222409.png';

  constructor(private readonly conn: ConnectionService) {}

  /**
   * Get allocated doctor information for a user
   * @param user Optional user object. If not provided, will fetch the acting user
   * @returns Promise<DoctorInfo> containing doctor's name and image URL
   */
  async getAllocatedDoctorInfo(user?: any): Promise<DoctorInfo> {
    try {
      // If user is not provided, get the acting user
      const targetUser = user ?? this.conn.getActingUser();
      if (!targetUser) {
        throw new Error('No user found');
      }

      let doctor: any;
      const allocatedDoctor = targetUser.get('allocatedDoctor');

      if (allocatedDoctor?.id) {
        doctor = await this.conn.findUserByObjectId(allocatedDoctor.id);
      }

      return {
        name: doctor?.get('DoctorDisplayName') ?? this.DEFAULT_DOCTOR_NAME,
        imageUrl: doctor?.get('doctorDisplayImage') ?? this.DEFAULT_DOCTOR_IMAGE
      };
    } catch (error) {
      console.error('Error fetching doctor info:', error);
      return {
        name: this.DEFAULT_DOCTOR_NAME,
        imageUrl: this.DEFAULT_DOCTOR_IMAGE
      };
    }
  }
}
